/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 8/10/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('RecordResourceFactory', function ($resource, EndPointService) {
		return $resource(EndPointService.recordEndPoint + '/:id', {id: '@id'},
			{
				'stop': {method: 'POST', url: EndPointService.recordEndPoint + '/:id/stop', params: {id: '@id'}, isArray:false},
				'update': {method: 'PUT', params: {id: '@id'}, isArray: false},
				'createClip': {method: 'POST', url: EndPointService.recordEndPoint + '/:id/clips', params: {id: '@id'}, isArray: false},
				'updateClip': {method: 'PUT', url: EndPointService.recordEndPoint + '/:id/clips/:clipId', params: {id: '@id', clipId: '@clipId'}, isArray: false},
				'getClips': {method: 'GET', url: EndPointService.recordEndPoint + '/:id/clips', params: {id: '@id'}, isArray: true},
				'saveThumbnail': {method: 'POST', url: EndPointService.recordEndPoint + '/:id/clips/:clipId/thumbnail',
					params: {id: '@id', clipId: '@clipId'}, isArray: false,
					headers : {'Content-Type': undefined}},
				'deleteClip': {method: 'DELETE', url: EndPointService.recordEndPoint + '/:id/clips/:clipId', params: {id: '@id'}, isArray:false}
			});
	});
